import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';
import { ActivityType } from '../enums/activity-type.enum';
import { DeviceMode } from '../enums/device-mode.enum';
import { ProviderType } from '../enums/provider-type.enum';

export class AvlDeviceAttributes extends Model {
  @Expose() battery: number;
  @Expose() distance: number;
  @Expose() event: number;
  @Expose() hours: number;
  @Expose() ignition: boolean;
  @Expose() motion: boolean;
  @Expose() power: number;
  @Expose() sat: number;
  @Expose() totalDistance: number;
  @Expose() alarm: string;
  @Expose() temp0: number;
  @Expose() io22: number;
  @Expose() io86: number;
  @Expose() bleTemp1: number;
  @Expose() isTempExceed?: boolean;
  @Expose() isHumidityExceed?: boolean;
  @Expose() activityType: ActivityType;
  @Expose() deviceMode: DeviceMode;
  @Expose() driverId: number;
  @Expose() isDevOptionEnabled: boolean;
  @Expose() isMockLocationEnabled: boolean;
  @Expose() isVpnEnabled: boolean;
  @Expose() providerType: ProviderType;
  @Expose() shipmentId: number;
  
  constructor() {
    super();
  }
}
